import { SVGAttributes } from "react";

export const PoizonComLogo = (props: SVGAttributes<SVGElement>) => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect width="24" height="24" rx="4" fill="black" />
      <path
        d="M5.51395 10.4229C5.51395 9.32849 5.06009 8.78451 4.15557 8.78125H2.53003V15.2094H3.47638V13.1686L4.39696 12.7308C4.65449 12.6182 4.88626 12.4604 5.08259 12.2641C5.23066 12.0999 5.34333 11.9068 5.41092 11.6976C5.48498 11.4336 5.52038 11.16 5.51395 10.8864V10.4229ZM4.46781 11.4014C4.38411 11.5559 4.24891 11.675 4.08797 11.7426L3.47638 12.042V9.71798H3.94312C4.16844 9.71798 4.33259 9.78235 4.42919 9.92073C4.52575 10.0592 4.57401 10.2555 4.57401 10.5227V10.8349C4.58369 11.028 4.54504 11.2212 4.46781 11.4014Z"
        fill="white"
      />
      <path
        d="M16.4646 8.71045H16.3068C15.3637 8.71045 14.8551 9.21903 14.8551 10.1622V13.8349C14.8551 14.778 15.3637 15.2866 16.3068 15.2866L16.4646 15.2898C17.4077 15.2898 17.9163 14.7813 17.9163 13.8381V10.1622C17.9163 9.21903 17.4077 8.71045 16.4646 8.71045ZM16.9957 13.7094C16.9957 14.086 16.7929 14.3628 16.4163 14.3628H16.3583C15.985 14.3628 15.779 14.086 15.779 13.7094V10.278C15.779 9.90145 15.9818 9.62464 16.3583 9.62464H16.4163C16.7929 9.62464 16.9957 9.90145 16.9957 10.278V13.7094Z"
        fill="white"
      />
      <path
        d="M10.8541 8.78125H9.86588V15.2094H10.8541V8.78125Z"
        fill="white"
      />
      <path
        d="M11.53 9.69544H13.3777L11.53 14.6654V15.2094H14.2564L14.4528 14.2888H12.6083L14.4528 9.31881V8.78125H11.7328L11.53 9.69544Z"
        fill="white"
      />
      <path
        d="M20.5268 8.78125V12.174L19.3068 8.78125H18.5955V15.2094H19.5386V11.7748L20.7586 15.2094H21.47V8.78125H20.5268Z"
        fill="white"
      />
      <path
        d="M7.71243 8.71045H7.55151C6.60835 8.71045 6.09976 9.21903 6.09976 10.1622V13.8349C6.09976 14.778 6.60835 15.2866 7.55151 15.2866L7.71243 15.2898C8.65555 15.2898 9.16413 14.7813 9.16413 13.8381V10.1622C9.16413 9.21903 8.65555 8.71045 7.71243 8.71045ZM8.24035 13.5903V13.7094C8.24035 14.086 8.03755 14.3628 7.66092 14.3628H7.60298C7.22639 14.3628 7.02359 14.086 7.02359 13.7094V10.278C7.02359 9.90145 7.22639 9.62464 7.60298 9.62464H7.66092C8.03755 9.62464 8.24035 9.90145 8.24035 10.278V13.5935V13.5903Z"
        fill="white"
      />
      <path
        d="M7.02042 13.6481L8.24035 12.1417V10.3391L7.02042 11.8456V13.6481Z"
        fill="#00FEFF"
      />
    </svg>
  );
};
